import { useLocation } from "react-router-dom"
import PropTypes from "prop-types"
import React from "react"
import { Helmet } from "react-helmet"

// Default metadata
const defaultMetadata = {
  defaultTitle: "CalendarBridge",
  titleTemplate: "%s | CalendarBridge",
  defaultDescription: "Sync calendars between accounts and schedule meetings easily",
  siteUrl: "https://calendarbridge.com",
  defaultImage: "/images/homepage_share_image.png",
  twitterUsername: "@calendarbridge",
}

const SEO = ({ title, description, image, article }) => {
  const { pathname } = useLocation()

  const seo = {
    title: title || defaultMetadata.defaultTitle,
    description: description || defaultMetadata.defaultDescription,
    image: `${defaultMetadata.siteUrl}${image || defaultMetadata.defaultImage}`,
    url: `${defaultMetadata.siteUrl}${pathname}`,
  }

  return (
    <Helmet title={seo.title} titleTemplate={defaultMetadata.titleTemplate}>
      <meta name="description" content={seo.description} />
      <meta name="image" content={seo.image} />
      <meta name="robots" content="noindex" />
      {seo.url && <meta property="og:url" content={seo.url} />}

      {(article ? true : null) && <meta property="og:type" content="article" />}

      {seo.title && <meta property="og:title" content={seo.title} />}

      {seo.description && (
        <meta property="og:description" content={seo.description} />
      )}

      {seo.image && <meta property="og:image" content={seo.image} />}

      <meta name="twitter:card" content="summary_large_image" />

      {defaultMetadata.twitterUsername && (
        <meta name="twitter:creator" content={defaultMetadata.twitterUsername} />
      )}

      {seo.title && <meta name="twitter:title" content={seo.title} />}

      {seo.description && (
        <meta name="twitter:description" content={seo.description} />
      )}

      {seo.image && <meta name="twitter:image" content={seo.image} />}
    </Helmet>
  )
}

export default SEO

SEO.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  image: PropTypes.string,
  article: PropTypes.bool,
}

SEO.defaultProps = {
  title: null,
  description: null,
  image: null,
  article: false,
}
